module.exports = __webpack_public_path__ + "img/timestudy-7.5a364724.png";